import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { Component, Inject } from '@angular/core';
import { DialogData } from 'studio-components/dialog/types/dialog-data.type';

import { ConfirmationDialogDataType } from '../../types/confirmation-dialog-data.type';

@Component({
  selector: 'studio-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
})
export class ConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogDataType & DialogData,
  ) {}
}
